import React from "react";
import "./index.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
export const Realisation = ({ realisations }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 1, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="realisation mt-5 mb-5">
      <div className="realisation-header">
        <div className="realisation-title">Nos réalisations</div>
        <div className="realisation-subtitle mt-3 mb-5">
          Des chantiers réussis qui parlent d’eux-mêmes.
        </div>
      </div>
      <Slider {...settings}>
        {realisations.map((realisation, index) => (
          <div className="house-card" key={index}>
            <div className="image-wrapper">
              <img src={realisation.image} alt="Maison" />
              <a href={realisation.link} className="link">
                <div className="overlay">
                  <p>{realisation.text}</p>
                </div>
              </a>
            </div>
            <div className="shape-bg"></div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
